import React, { lazy } from 'react';

//Subcontractor Digital Reporting
const SubcontractorReportingSubmenu = lazy(() =>
  import('./SubcontractorReportingSubmenu').then(module => ({
    default: module.SubcontractorReportingSubmenu,
  })),
);

const SubcontractorAdvanceLedgerReport = lazy(() =>
  import('./PreviewPage/SubcontractorAdvanceLedgerReport').then(module => ({
    default: module.SubcontractorAdvanceLedgerReport,
  })),
);

const SubcontractorLedgerReport = lazy(() =>
  import('./PreviewPage/SubcontractorLedgerReport').then(module => ({
    default: module.SubcontractorLedgerReport,
  })),
);

const SubcontractorLedgerReportByDocDate = lazy(() =>
  import('./PreviewPage/SubcontractorLedgerReportByDocDate').then(module => ({
    default: module.SubcontractorLedgerReportByDocDate,
  })),
);

const SubcontractorAgingDetailbyProject = lazy(() =>
  import('./PreviewPage/SubcontractorAgingDetailbyProject').then(module => ({
    default: module.SubcontractorAgingDetailbyProject,
  })),
);

const SubcontractorAgingDetailReportbyTrxDate = lazy(() =>
  import('./PreviewPage/SubcontractorAgingDetailReportbyTrxDate').then(
    module => ({
      default: module.SubcontractorAgingDetailReportbyTrxDate,
    }),
  ),
);

const SubcontractorAgingDetailReportbyDocDate = lazy(() =>
  import('./PreviewPage/SubcontractorAgingDetailReportbyDocDate').then(
    module => ({
      default: module.SubcontractorAgingDetailReportbyDocDate,
    }),
  ),
);

const SubcontractorAgingSummaryReportbyTrxDate = lazy(() =>
  import('./PreviewPage/SubcontractorAgingSummaryReportbyTrxDate').then(
    module => ({
      default: module.SubcontractorAgingSummaryReportbyTrxDate,
    }),
  ),
);

const SubcontractorAgingSummaryReportbyProject = lazy(() =>
  import('./PreviewPage/SubcontractorAgingSummaryProjectReport').then(
    module => ({
      default: module.SubcontractorAgingSummaryReportbyProject,
    }),
  ),
);

const SubcontractorDetailBreakdownReport = lazy(() =>
  import('./PreviewPage/SubcontractorDetailBreakdownReport').then(module => ({
    default: module.SubcontractorDetailBreakdownReport,
  })),
);

const SubcontractorLedgerReportbyProject = lazy(() =>
  import('./PreviewPage/SubcontractorLedgerReportbyProject').then(module => ({
    default: module.SubcontractorLedgerReportbyProject,
  })),
);

const SubcontractorControlSummaryReport = lazy(() =>
  import('./PreviewPage/SubcontractorControlSummaryReport').then(module => ({
    default: module.SubcontractorControlSummaryReport,
  })),
);

const SubcontractorRetentionLedgerReport = lazy(() =>
  import('./PreviewPage/SubcontractorRetentionLedgerReport').then(module => ({
    default: module.SubcontractorRetentionLedgerReport,
  })),
);

const SubcontractorEInvoiceReport = lazy(() =>
  import('./PreviewPage/SubcontractorEInvoiceReport').then(module => ({
    default: module.SubcontractorEInvoiceReport,
  })),
);

const subcontractorReportingRoutes = [
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID',
    },
    component: <SubcontractorReportingSubmenu />,
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/advance-ledger-report/view',
    },
    component: (
      <SubcontractorAdvanceLedgerReport reportMode="advance-ledger-report" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/ledger-report/view',
    },
    component: <SubcontractorLedgerReport reportMode="ledger-report" />,
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/ledger-report-docdate/view',
    },
    component: (
      <SubcontractorLedgerReportByDocDate reportMode="ledger-report-docdate" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/aging-detail-project/view',
    },
    component: (
      <SubcontractorAgingDetailbyProject reportMode="aging-detail-project" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/aging-detail-trxdate/view',
    },
    component: (
      <SubcontractorAgingDetailReportbyTrxDate reportMode="aging-detail-trxdate" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/aging-detail-docdate/view',
    },
    component: (
      <SubcontractorAgingDetailReportbyDocDate reportMode="aging-detail-docdate" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/aging-summary-trxdate/view',
    },
    component: (
      <SubcontractorAgingSummaryReportbyTrxDate reportMode="aging-summary-trxdate/" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/aging-summary-project/view',
    },
    component: (
      <SubcontractorAgingSummaryReportbyProject reportMode="aging-summary-project/" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/detail-breakdown-report/view',
    },
    component: (
      <SubcontractorDetailBreakdownReport reportMode="detail-breakdown-report" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/ledger-report-project/view',
    },
    component: (
      <SubcontractorLedgerReportbyProject reportMode="ledger-report-project" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/control-summary-report/view',
    },
    component: (
      <SubcontractorControlSummaryReport reportMode="control-summary-report" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/retention-ledger-report/view',
    },
    component: (
      <SubcontractorRetentionLedgerReport reportMode="retention-ledger-report" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/e-invoice-report/view',
    },
    component: <SubcontractorEInvoiceReport reportMode="e-invoice-report" />,
  },

  {
    props: {
      exact: true,
      path: '/subcontractor/digital-reporting/:subcontractorID/parameter/e-invoice-report-po/view',
    },
    component: (
      <SubcontractorEInvoiceReport
        reportMode="e-invoice-report-po"
        module="project-purcchase"
      />
    ),
  },
];

export default subcontractorReportingRoutes;
